module.exports = __webpack_public_path__ + "static/img/hk.9fe81650.svg";